module.exports = __webpack_public_path__ + "static/media/ASIANPAINT.e3329f70.txt";